import { render } from "./mega-menu.vue?vue&type=template&id=4ab34859"
import script from "./mega-menu.vue?vue&type=script&lang=js"
export * from "./mega-menu.vue?vue&type=script&lang=js"

import "./mega-menu.vue?vue&type=style&index=0&id=4ab34859&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__